import { Injectable } from '@angular/core';
import { AbstractSaveOneService } from 'src/app/modules/core/service/v2/service/save/abstractSaveOne.service';
import {TagModel} from "../model/tag.model";
import {TagRepository} from "../../impl/service/ngrx/tag.repository";
import {TagDataServiceAdapter} from "../../impl/service/ngrx/tagDataService.adapter";

@Injectable()
export class TagSaveService extends AbstractSaveOneService<TagModel, TagSavePayload> {

    constructor(repository: TagRepository,
        dataServiceAdapter: TagDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}

export class TagSavePayload {
    entityTypeValue: string;
    name: string;
    color: string;
}
